import React from "react";
import { Box, Stack, Text, Title, TitleOrder } from "@mantine/core";
import styles from "./PageHeader.module.css";

export interface PageHeaderProps {
  /** Page title rendered as a Mantine Title. */
  title: React.ReactNode;
  /** Optional subtitle / description rendered under the title. */
  subtitle?: React.ReactNode;
  /** Heading order. Defaults to 2. */
  titleOrder?: TitleOrder;
  /** Action elements rendered on the right (search inputs, buttons, icon menus). */
  actions?: React.ReactNode;
  /** Slot above the title row (e.g. breadcrumb / back link). */
  above?: React.ReactNode;
  className?: string;
}

/**
 * Standard page header: title (and optional subtitle) on the left, action
 * controls on the right. Used across list pages (Products, Clients, etc.)
 * to keep page chrome consistent.
 */
export default function PageHeader({
  title,
  subtitle,
  titleOrder = 2,
  actions,
  above,
  className,
}: PageHeaderProps) {
  return (
    <Stack gap="xs" className={className}>
      {above}
      <Box className={styles.header}>
        <Stack gap={0} className={styles.titleBlock}>
          <Title order={titleOrder}>{title}</Title>
          {subtitle ? (
            <Text size="sm" c="dimmed">
              {subtitle}
            </Text>
          ) : null}
        </Stack>
        {actions ? <Box className={styles.actions}>{actions}</Box> : null}
      </Box>
    </Stack>
  );
}
